import { toggleHidden } from 'src/utils/dom-toggle';
import { Context, Controller } from '@hotwired/stimulus';

export default class EmployeeStartDateInputController extends Controller {
  public static targets = ['input', 'futureWarning', 'extremeFutureWarning'];

  public static values = {};

  private declare inputTarget: HTMLInputElement;
  private declare futureWarningTarget: HTMLElement;
  private declare extremeFutureWarningTarget: HTMLElement;

  public constructor(context: Context) {
    super(context);

    this.onDateChanged = this.onDateChanged.bind(this);
  }

  connect(): void {
    super.connect();

    this.inputTarget.addEventListener('change', this.onDateChanged);
  }

  disconnect(): void {
    super.disconnect();

    this.inputTarget.removeEventListener('change', this.onDateChanged);
  }

  private onDateChanged(_: Event) {
    const enteredDate = this.inputTarget.valueAsDate;

    if (enteredDate) {
      const difference = new Date().getTime() - enteredDate.getTime();

      const warningVisible = difference < -1 * 1000 * 60 * 60 * 18;
      const errorVisible = difference < -1 * 1000 * 60 * 60 * 24 * 365 * 1;

      toggleHidden(this.futureWarningTarget, errorVisible || !warningVisible);
      toggleHidden(this.extremeFutureWarningTarget, !errorVisible);
    } else {
      toggleHidden(this.futureWarningTarget, true);
      toggleHidden(this.extremeFutureWarningTarget, true);
    }
  }
}
